export const plans = {
  // ヘッダー
  title: 'プランを選ぶ',
  subtitle: 'いつでもプランの変更・解約ができます。毎月25日に翌月分が更新されます。',

  // 無料モード（FREE_MODE 運用中）
  freeTitle: '現在は無料でご利用いただけます',
  freeDescription: 'テスティング期間中のため、すべての機能を無料でご利用いただけます。お支払いは必要ありません。プラン選択や課金は、有料化のタイミングで開始します。',
  freeCta: 'マイページへ',

  // 契約中バナー
  activeBanner: '現在プランが有効です。変更する場合は下から選択してください。',

  // プラン共通
  perMonthUnit: '回 / 月',
  popularBadge: '人気',
  selectButton: 'このプランにする',
  processing: '処理中...',
  checkoutError: 'チェックアウトの作成に失敗しました',
  freeModeError: '現在は無料モードのため、チェックアウトは作成できません。',

  // プラン定義
  basicName: 'Basic',
  basicDesc: '月4回のレッスン。まずは気軽にスタートしたい方に。',
  plus2Name: 'Plus 2',
  plus2Desc: '月6回。週1〜2回ペースでしっかり続けたい方に。',
  plus4Name: 'Plus 4',
  plus4Desc: '月8回。集中的に伸ばしたい方に。',

  // 補足
  note1: '初回2回は無料（フィードバックアンケートの条件付き）',
  note2: '1回分は翌月に持ち越し可能',
  note3: '毎月15日までに手続きで翌月解約',
  note4: 'テスティング期間中は特別価格でご利用いただけます',
};
